import { ApiCore } from '@/services/api/utils/core.js'
import { apiProvider } from '@/services/api/utils/provider.js'
import axios from 'axios'
import { handleResponse, handleError } from '@/services/api/utils/response.js'

const url = 'v1/filters'
const plural = 'filters'
const single = 'filter'

const api = new ApiCore({
	index: true,
	url: url,
	plural: plural,
	single: single
})

api.index = (params) => {
	return axios
		.get(`${apiProvider.BASE_URL}/${url}`, params)
		.then(handleResponse)
		.catch(handleError)
}

export default api
